import { AuthenticationService } from './authentication.service';
import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { UserRightsService } from './user-rights.service';
import { ModalService } from './modal.service';

// const _PROMO_URL: string = 'https://minibiz.rs/cenovnik';
const _PROMO_URL: string = 'https://minibiz.rs/funkcionalnosti';

@Injectable({
    providedIn: 'root'
})
export class AuthGuardService{
    constructor(
        private authenticationService: AuthenticationService,
        private router: Router,
        private userRightsService: UserRightsService,
        private modalService: ModalService){

        }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Promise<boolean>{
        if(this.authenticationService.GetAccessToken() == ''){
            this.redirectToLoginPage();
            return false;
        }
        else if(this.authenticationService.GetAccessToken() != ''){
            //return true;
            let modelName = route.data.mainList ? route.data.mainList.userRightsModelName ? route.data.mainList.userRightsModelName : route.data.mainList.modelName : '';
            let hasRights = this.hasRights(modelName);
            if(!hasRights){
                this.redirectToPromo(route);
            }
            return hasRights;
        }
        else{
            this.authenticationService.RefreshToken();
            return true;
        }
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Promise<boolean>{
        if(this.authenticationService.GetAccessToken() == ''){
            this.redirectToLoginPage();
            return false;
        }

        let modelName = route.data.mainList ? route.data.mainList.userRightsModelName ? route.data.mainList.userRightsModelName : route.data.mainList.modelName : '';
        let hasRights = this.hasRights(modelName);
        if(!hasRights){
            this.redirectToPromo(route);
        }
        return hasRights;
    }

    redirectToLoginPage(){
        this.router.navigate(['/login'], { queryParams: { returnUrl: this.router.url }});
    }

    hasRights(modelName) {
        if(modelName === '') {
            return true;
        }

        return this.userRightsService.GetUserRightValue(modelName, 'isEnabled');
    }

    private redirectToPromo(route: ActivatedRouteSnapshot){
        //window.open(_PROMO_URL, "_blank");
        // let path = '/' + route.parent.parent.routeConfig == null ? 'lookups' : route.parent.parent.routeConfig.path + '/' + route.routeConfig.path;
        
        // let path = '/' + route.parent.parent.routeConfig.path + '/' + route.routeConfig.path;
        let path = route["_routerState"].url;
        this.modalService.ShowPromoDialog(path);
    }
}